import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e7d6bf1")

_pushScopeId("data-v-4e7d6bf1")
const _hoisted_1 = { class: "w-full pt-2 pb-4 px-4 h-full bg-gray-lp-1200" }
const _hoisted_2 = { class: "bg-white w-full h-full rounded-xl p-4" }
const _hoisted_3 = {
  key: 1,
  class: "cargo-table"
}
const _hoisted_4 = { class: "flex flex-col items-start break-all text-left" }
const _hoisted_5 = { class: "flex flex-col gap-1 text-gray-lp-300 text-sm" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_10 = { class: "flex flex-col gap-1 text-sm text-gray-lp-300" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-row items-center gap-1 flex-wrap"
}
const _hoisted_13 = {
  key: 0,
  class: "text-blue-600 text-xs"
}
const _hoisted_14 = {
  key: 2,
  class: "flex flex-row items-center gap-2 flex-wrap"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "rounded-full bg-gray-200 px-2 py-0.5 text-xs text-gray-lp-300"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CargoV2FilterSection = _resolveComponent("CargoV2FilterSection")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_CargoV2FilterSection, {
        summary: {},
        initialFilter: _ctx.localFilter,
        isSuccessBookingTab: false,
        onSearch: _ctx.onSearch,
        onChange: _ctx.onFilterChange
      }, null, 8, ["initialFilter", "onSearch", "onChange"]),
      (_ctx.cargoListAvailable)
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 0,
            customMessage: _ctx.$t('cargo.messages.noData')
          }, null, 8, ["customMessage"]))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_TableV2, {
              columns: _ctx.columns,
              data: _ctx.inProgressList,
              loading: _ctx.isLoading,
              pagination: _ctx.inProgressPagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inProgressPagination = $event)),
              paginationStyle: "v3",
              onRequest: _ctx.fetchList,
              errorCause: _ctx.errorCause,
              isDetailAble: true,
              onClick: _ctx.onClickRow,
              isSpaceTop: false,
              bgHeader: "bg-white border-b border-gray-lp-200",
              paginationV3PaddingVertical: 'py-4',
              customClassPagination: 
            'absolute w-full bottom-4 right-0 left-0 -mb-4 px-8'
          ,
              pinnedSubstractHeight: "340px",
              isPinnedScrollBottom: "",
              isNoPaddingBottom: "",
              isTabList: false
            }, {
              no_booking: _withId(({ item }) => [
                _createVNode("div", _hoisted_4, _toDisplayString(_ctx.displayBookingNo(item)), 1)
              ]),
              origin_destination: _withId(({ item }) => [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _withDirectives(_createVNode("span", null, [
                      _createTextVNode(_toDisplayString(item.originCityCode), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        item.originCityName,
                        void 0,
                        { bottom: true }
                      ]
                    ]),
                    _hoisted_7,
                    _withDirectives(_createVNode("span", null, [
                      _createTextVNode(_toDisplayString(item.destinationCityCode), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        item.destinationCityName,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]),
                  (item.cargoType === 'plane')
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        _withDirectives(_createVNode("span", null, [
                          _createTextVNode(_toDisplayString(item.airportOriginCityCode), 1)
                        ], 512), [
                          [
                            _directive_tooltip,
                            item.airportOriginCityName,
                            void 0,
                            { bottom: true }
                          ]
                        ]),
                        _hoisted_9,
                        _withDirectives(_createVNode("span", null, [
                          _createTextVNode(_toDisplayString(item.airportDestinationCityCode), 1)
                        ], 512), [
                          [
                            _directive_tooltip,
                            item.airportDestinationCityName,
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              etd: _withId(({ item }) => [
                _createVNode("div", _hoisted_10, [
                  (item.departureDate)
                    ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.formatDate(item.departureDate)), 1))
                    : _createCommentVNode("", true),
                  (item.departureDate && item.arrivalDate)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _createVNode("span", null, _toDisplayString(_ctx.formatDate(item.departureDate, "HH:mm")) + " - " + _toDisplayString(_ctx.formatDate(item.arrivalDate, "HH:mm")), 1),
                        (_ctx.etdDayOffset(item) > 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.etdDayOffsetLabel(item)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (item.vehiclePoliceNumber || item.totalTransit > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        (item.vehiclePoliceNumber)
                          ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(item.vehiclePoliceNumber), 1))
                          : _createCommentVNode("", true),
                        (item.totalTransit > 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(item.totalTransit) + " transit ", 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["columns", "data", "loading", "pagination", "onRequest", "errorCause", "onClick"])
          ]))
    ])
  ]))
})